import * as React from "react";
import { Folder, History, PlayCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useToggle } from "react-use";
import { CreateCollectionModal } from "@/modules/snapshots/modals/createCollectionModal";
import { CommonTabs } from "@/components/app/tabs";
import { CommonTabsItem } from "@/components/app/tabs/types";

interface Props {
  selectedTab: string;
  children?: React.ReactNode;
}

const tabs: CommonTabsItem[] = [
  {
    name: "templates",
    label: "Templates",
    icon: (
      <PlayCircle className="mr-2 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-data-[state=active]:text-desert-sand-700" />
    ),
  },
  {
    name: "recent",
    label: "Recent Snapshots",
    icon: (
      <History className="mr-2 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-data-[state=active]:text-desert-sand-700" />
    ),
  },
  {
    name: "collections",
    label: "Collections",
    icon: (
      <Folder className="mr-2 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-data-[state=active]:text-desert-sand-700" />
    ),
  },
];

export const BusinessReportsTabs: React.FC<Props> = ({ selectedTab }) => {
  const [isCreateCollectionOpen, toggleIsCreateCollectionOpen] = useToggle(false);

  return (
    <CommonTabs tabs={tabs}>
      {selectedTab === "collections" && (
        <div className="ml-auto">
          {isCreateCollectionOpen && (
            <CreateCollectionModal isOpen={isCreateCollectionOpen} setIsOpen={toggleIsCreateCollectionOpen} />
          )}

          <Button variant="default" size="sm" onClick={toggleIsCreateCollectionOpen}>
            Create SnapShot Collection
          </Button>
        </div>
      )}
    </CommonTabs>
  );
};
